export default from './MobileMenu';



// WEBPACK FOOTER //
// ./src/layouts/NonAuthLayout/components/Menu/components/MobileMenu/index.js